import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const postVerifyTopUpService = () => {
  return privateRequest.post(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL_VERIFY}`);
};
